import React from 'react';

const ArrowIcon = ({ style = {}, fill = 'var(--text-level-3)', width = '16', height = '16', className = '', viewBox = '0 0 16 16' }) => (
  <svg width={width} style={style} height={height} viewBox={viewBox} className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 9.51005L3.74094 6L3 6.87932L8 11L13 6.87932L12.2591 6L8 9.51005Z" fill={fill} />
  </svg>
);

export default ArrowIcon;
